import IFindFavorecidosContaBancariaResponse from '../entities/IFindFavorecidosContaBancariaResponse'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface IFindFavorecidosContaBancaria {
  execute(frotistaId: number): Promise<IFindFavorecidosContaBancariaResponse[]>
}

export default class FindFavorecidosContaBancariaImpl
  implements IFindFavorecidosContaBancaria
{
  constructor(private readonly pagamentoRepository: IPagamentoRepository) {}
  async execute(
    frotistaId: number,
  ): Promise<IFindFavorecidosContaBancariaResponse[]> {
    const response =
      await this.pagamentoRepository.findFavorecidosContaBancaria(frotistaId)
    return response
  }
}
